import chartDisplaySettings from "./chartDisplaySettings.js";

/**
 * Period selection for the chart.
 */
function periodSelection() {
	const that = {};

	let selectedPeriod;

	that.getSelectedPeriod = function () {
		return selectedPeriod;
	};

	that.setSelectedPeriod = function (period) {
		selectedPeriod = period;
	};

	that.selectPlotBand = function (plotLinesAndBands, periodToSelect) {
		selectedPeriod = periodToSelect;

		plotLinesAndBands.forEach((plotBand) => {
			const period = plotBand.options.period;
			if (period && period === periodToSelect) {
				plotBand.options.color = chartDisplaySettings.highlightColor;
			} else if (
				plotBand.options.color === chartDisplaySettings.highlightColor
			) {
				plotBand.options.color = chartDisplaySettings.backgroundColor;
			}
			plotBand.svgElem.attr("fill", plotBand.options.color);
		});
	};

	return that;
}

export default periodSelection;
